<p-fieldset legend="Amostras">
  <div class="row">
    <label class="required col-2 col-form-label">
      Há exigência de amostras?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="objeto.AmostraNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
  <div class="row" *ngIf="objeto.AmostraNao === 'S'">
    <label class="required col-2 col-form-label">
      Item do Edital
    </label>
    <input type="text" class="col-3 form-control" [(ngModel)]="objeto.Amostra.AmostrasItem"
      [ngModelOptions]="{standalone: true}">
  </div>
</p-fieldset>